import React, {Fragment} from 'react';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import {AddressFormatter, CurrencyFormatter} from "../../../utils/formatters";
import Icon from "../../form/Icon";
import {providerTypes, invoiceTypes} from "../invoiceEditor";

const percentColors = [
    {pct: 0.0, color: {r: 13, g: 219, b: 13}},
    {pct: 1.0, color: {r: 255, g: 0, b: 0}}];

const getColorForPercentage = function (pct) {
    let i = 1;
    for (; i < percentColors.length - 1; i++) {
        if (pct < percentColors[i].pct) {
            break;
        }
    }
    let lower = percentColors[i - 1];
    let upper = percentColors[i];
    let range = upper.pct - lower.pct;
    let rangePct = (pct - lower.pct) / range;
    let pctLower = 1 - rangePct;
    let pctUpper = rangePct;
    let color = {
        r: Math.floor(lower.color.r * pctLower + upper.color.r * pctUpper),
        g: Math.floor(lower.color.g * pctLower + upper.color.g * pctUpper),
        b: Math.floor(lower.color.b * pctLower + upper.color.b * pctUpper)
    };
    return 'rgb(' + [color.r, color.g, color.b].join(',') + ')';
    // or output as hex if preferred
}

class invoiceList extends React.Component {

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const filterable = true;
        const sortable = true;
        const {view, componentConfig, filter, selection, isLoading, className, pageSize} = this.props;
        const props = {componentConfig, filter, loading: isLoading, pageSize: pageSize || 5, formId: this.props.formId};
        if (view) {
            props.view = view;
        }
        return (
            <SelectorGrid
                ref={(el) => this.list = el}
                gridid={this.props.gridid !== undefined ? this.props.gridid : "invoiceList"}
                {...props}
                view={["serviceprovider_type", "component", "component_id", "client_component", "client_component_id", "currency", "from.partner_id", "to.partner_id", "acting", "type", "transaction.balance", "transaction.total", "transaction.amount"]}
                columns={{
                    "billnum": {
                        header: 'Sorszám',
                        width: 1,
                        sortable,
                        filterable,
                        renderer: (value, rowData) => {
                            const roundAmount = Math.round(rowData.transaction.amount);
                            const roundBalance = Math.round(rowData.transaction.balance);
                            const percent = (Math.abs(roundBalance) / roundAmount).toFixed(2);
                            return <Fragment>{parseFloat(rowData.transaction.balance) !== 0 ? <Icon style={{color: getColorForPercentage(percent)}} className="pull-right" lib="fas" name={parseInt(rowData.transaction.balance) > 0 ? "money-bill-wave" : "money-bill"} tooltip={<Fragment>Teljes összeg: {CurrencyFormatter(rowData.transaction.amount).props.children} <br/>Kiegyenlítetetlen összeg: {CurrencyFormatter(rowData.transaction.balance).props.children}</Fragment>}/> : null} {value}</Fragment>;
                        }
                    },
                    "partner_name": {
                        header: 'Partner',
                        width: 2,
                        sortable,
                        filterable
                    },
                    "partner_address": {
                        header: 'Partner címe',
                        width: 2,
                        renderer: AddressFormatter
                    },
                    "totalprice": {
                        header: 'Végösszeg',
                        width: 1,
                        renderer: CurrencyFormatter,
                        sortable,
                        filterable
                    },
                    "issuedate": {
                        header: 'Dátum',
                        width: 1,
                        sortable,
                        filterable
                    },
                    "transactiondate": {
                        header: 'Teljesítés',
                        width: 1,
                        sortable,
                        filterable
                    },
                    "deadline": {
                        header: 'Határidő',
                        width: 1,
                        sortable,
                        filterable
                    }
                }}
                rowClassName={(rowData) => {
                    return {
                        "danger color": invoiceTypes.STORNO(rowData.type),
                        "info": invoiceTypes.PROFORM(rowData.type),
                        "warning": invoiceTypes.EDITABLE(rowData.type)
                    };
                }}
                onLoadCompleted={(data) => {
                    if (this.props.isAllExternal) {
                        const rows = (data.rows || []);
                        if (rows.length > 0 && rows.filter((row) => providerTypes.ExternalInvoice(row.serviceprovider_type)).length === rows.length) {
                            const invoice = rows[0];
                            this.props.isAllExternal({
                                client_component: invoice.client_component,
                                client_component_id: invoice.client_component_id,
                                to: invoice.to,
                                from: invoice.from,
                                acting: invoice.acting,
                                currency: invoice.currency,
                            });
                        } else {
                            this.props.isAllExternal(false);
                        }
                    }
                }}
                sortBy={[
                    {expression: "{{billnum}} IS NULL", direction: "DESC"},
                    {field: "billnum", direction: "DESC"},
                ]}
                selectionMode={this.props.selectionMode}
                orderBy={{field: "transactiondate", direction: "DESC"}}
                selection={selection}
                onSelectionChange={(selection) => this.props.loadForm(selection.value)}
            />
        );
    }
}

export default invoiceList;
